import AuthContext from 'context/AuthContext';
import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export const PrivateRoutes = () => {
  const {authenticated} = useContext(AuthContext);

  return authenticated ? <Outlet /> : <Navigate to="/auth/sign-in" />;
};
